import { render, staticRenderFns } from "./Header-co.vue?vue&type=template&id=3dfa0381"
import script from "./Header-co.vue?vue&type=script&lang=js"
export * from "./Header-co.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports